import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { DownTimeReasonService } from "./downtimereason.service";
import { DownTimeReason } from "./dto/downtimereason.entity";
import { DownTimeReasonAdapter } from "./dto/downtimereason.adapter";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { DownTimeReasonController } from "./downtimereason.controller";
import { LogsService } from "@gtpl/shared-services/user-logs";

@Module({

    imports:[TypeOrmModule.forFeature([DownTimeReason]),

],
controllers:[DownTimeReasonController],
providers:[DownTimeReasonService,DownTimeReasonAdapter,ApplicationExceptionHandler,LogsService],
exports:[DownTimeReasonService],

})
export class DowntimeReasonModule{}